import {customElement} from "lit/decorators.js";
import {TabModel} from "../../common/tabModel";
import {UnLitElement} from "../../common/elements";
import {KEYS, prepareEvents} from "../../common/utils/events";
import {ManagingResources} from "../../common/lifetime";


@customElement("eop-binary-content-switch")
export class EopBinaryContentSwitch extends ManagingResources(UnLitElement) {
    private labels: TabModel;
    private contents: TabModel;
    private switchButton: HTMLElement;
    private toggled: boolean = false;

    public constructor() {
        super();

        this.labels = new TabModel(this, this.querySelectorAll(".binary-switch-label")).periodicSwitch({class: "active"});
        this.contents = new TabModel(this, this.querySelectorAll(".binary-switch-content")).periodicSwitch({class: "active"});
        this.switchButton = this.querySelector<HTMLElement>(".binary-switch-button")!;
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.switchButton.setAttribute("role", "switch");
        this.switchButton.setAttribute("tabindex", "0");
        this.switchButton.setAttribute("aria-checked", "false");

        this.switchButton.addEventListener("click", () => {
            this.toggle();
        });

        prepareEvents(this.switchButton)
            .boundTo(this)
            .on("keydown", (event: Event) => {
                const keyEvent = event as KeyboardEvent;
                if (keyEvent.key === KEYS.ENTER || keyEvent.key === KEYS.SPACE || keyEvent.key === KEYS.ARROW_LEFT || keyEvent.key === KEYS.ARROW_RIGHT) {
                    event.preventDefault();
                    this.toggle();
                }
            });
    }

    private toggle(): void {
        this.toggled = !this.toggled;
        if (this.toggled) {
            this.switchButton.classList.add("toggled");
        } else {
            this.switchButton.classList.remove("toggled");
        }
        this.switchButton.setAttribute("aria-checked", this.toggled ? "true" : "false");
        this.labels.selectNext();
        this.contents.selectNext();
    }
}